import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { COLORS } from 'COLORS'
import { CollapseIconV1 as CollapseIcon } from 'icons/CollapseIcon/CollapseIcon'

const Styles = styled.div`
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  padding: 5px 10px 5px 5px;
  margin-top: -15px;
  margin-bottom: 15px;
  width: fit-content;
  border-radius: 2px;
  &:hover {
    ${props =>
      props.enableHoverStyle !== false &&
      `
      background-color: ${COLORS.grey200};
    `}
  }
  display: flex;
  align-items: center;
  transition: all 150ms ease;
`

const BackButton = ({
  linkText,
  path,
  className = '',
  iconColor = COLORS.grey400,
  enableHoverStyle = true,
  onClick,
  dataId = ''
}) => {
  const navigate = useNavigate()

  const clickHandler = onClick || (() => navigate(path))

  return (
    <Styles
      onClick={clickHandler}
      className={className}
      enableHoverStyle={enableHoverStyle}
      data-id={dataId}>
      <CollapseIcon
        width="13px"
        height="13px"
        viewBox="0 0 26 26"
        color={iconColor}
      />
      <div>{linkText}</div>
    </Styles>
  )
}

BackButton.propTypes = {
  linkText: PropTypes.string.isRequired,
  path: PropTypes.string,
  onClick: PropTypes.func,
  enableHoverStyle: PropTypes.bool,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  dataId: PropTypes.string
}

export { BackButton }
